import i18n from "./i18n";

export default i18n;